import { memo } from "react";

import { initialDataWithPagination } from "services/api/consts";
import { TableSearch } from "ui/components/Table/TableSearch";

import { FLEET_TRANSFER_SEARCH_COLUMNS } from "./consts";
import { TransferSearchResultsProps } from "./types";

const TransferSearchResults: React.FC<TransferSearchResultsProps> = (props) => {
  const { searchResults, isLoading, onPaginationChange, onVehicleClick } = props;

  return (
    <TableSearch
      columns={FLEET_TRANSFER_SEARCH_COLUMNS(onVehicleClick)}
      data={searchResults.data}
      pagination={searchResults.pagination || initialDataWithPagination.pagination}
      selectableRows={false}
      onPaginationChange={onPaginationChange}
      isLoading={isLoading}
    />
  );
};

export default memo(TransferSearchResults);
